import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from 'src/app/_LOGIC/__common/functions.service';
import { ConfigService } from 'src/app/_LOGIC/__config/config.service';
import { ShopifyService } from 'src/app/_LOGIC/__shopify/shopify.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {

  testimonials = [
    /* {
      name: 'Maria José',
      career: 'Consultora',
      studies: 'Máster en Projectos',
      university: 'EAE',
      testimonial: 'Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat',
      imageUrl: 'https://images.unsplash.com/photo-1588361035994-295e21daa761?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=301&ixid=eyJhcHBfaWQiOjF9&ixlib=rb-1.2.1&q=50&w=301',
    }, */
    {
      name: 'Iván G',
      career: 'Ingeniero Industrial',
      studies: 'Máster en Management',
      university: 'EAE',
      testimonial: '"Era el servicio que buscaba, y el precio se adaptaba a mis necesidades. Me inspiraron confianza con la experiencia que tienen viviendo y trabajando en Europa. Estoy contento y agradecido de haber reservado con ellos ya que me facilitaron todo el proceso!"',
      spriteClass: 'testimonialivanGuerraPeq',
      imageUrl: "https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/2cb26c36-23cc-4679-a7ce-69f6ef613a00/public",
      year: ''
    },
    {
      name: 'Andrés P',
      career: 'Project Manager & Marketing',
      studies: 'Máster en Mercadeo con Dirección de Empresas',
      university: 'EUDE',
      testimonial: '"Desde el primer momento me transmitieron mucha confianza al ser jóvenes y profesionales activos en España, y con la experiencia que ya tienen viviendo en Europa. Tienen amplio conocimiento de los procesos a seguir y han documentado todo muy bien! Lo recomendaría 100%."',
      spriteClass: 'testimonialandresPrietoPeq',
      imageUrl: "https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f3b08955-7e2c-4e3c-653b-5a090b2a7500/public",
      year: ''
    },
    {
      name: 'Giancarlo',
      studies: 'Máster en Fisioterapia',
      career: 'Msc. Fisioterapeuta',
      university: 'UPM',
      testimonial: 'Me facilitaron todos los procesos incómodos relacionados a extranjería, me ayudaron a adaptarme y me ahorraron bastantes disgustos. Sinceramente creo que fue la mejor decisión solicitar consejos ya que al principio tenía muchas dudas que al final pude resolver.',
      spriteClass: 'testimonialgiancarloLucarPeq',
      imageUrl: "https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/0ff887fa-8b69-4351-d3c7-02325a66ef00/public",
      year: ''
    },
    {
      name: 'Alejandro Cedeño',
      career: 'Ingeniero Civil',
      studies: 'Máster en Arquitectura, Diseño y Administración de empresas',
      university: 'UIC',
      spriteClass: 'testimonialalecedePeq',
      testimonial: 'Fueron clave en los procesos de extranjería cuando llegué a España. La información suele estar muy dispersa y pero con la ayuda de ellos pude organizarmme mejor y cumplir con todos los plazos para no tener ningún problema.',
      imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/8ea44043-a792-4892-6c42-e39df8897900/public',
      year: '2023'
    },
/*     {
      name: 'Melissa Álvarez',
      career: '',
      studies: '',
      university: '',
      testimonial: '',
      imageUrl: 'https://i.ibb.co/8x9xK4H/team.jpg',
      year: ''
    }, */
    /* {
      name: 'Eric Rojas',
      career: '',
      studies: '',
      university: '',
      testimonial: '',
      imageUrl: 'https://i.ibb.co/8x9xK4H/team.jpg',
      year: ''
    } */
  ];

  @ViewChild('testimonial') testimonial: ElementRef<HTMLDivElement>;
  @ViewChild('home') home: ElementRef<HTMLDivElement>;
  @ViewChild('packsoffer') packsoffer: ElementRef<HTMLDivElement>;
  
  routes = [];

  constructor(private router: Router,private activatedRoute: ActivatedRoute,private commonFunctions: FunctionsService,private shopifyService: ShopifyService,private configService: ConfigService) { }

  ngOnInit(): void {
    // Imprimir la ruta completa
    //console.log(this.router.url);
    // Acceder a las secciones de la ruta
    let ruta = this.activatedRoute.snapshot.pathFromRoot
      // Mapear cada segmento de la ruta
      .map(v => v.url.map(segment => this.routes.push(segment)))
      // Filtrar segmentos vacíos
      .filter(v => v);
      /* console.log(ruta); */
  }

  ngAfterViewInit() {
    this.scroll();
  }

  scroll(){
    if(this.routes[0] && this.routes[0].path == 'home'){
      if(this.routes[1] && this.routes[1].path == 'testimonial'){
        this.scrollToElement('testimonial');
      }else{
        this.commonFunctions.scrollToTop();
      }
    }
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }

  scrollToElement(label): void {

    switch(label){
      case 'testimonial':
        if (this.testimonial && this.testimonial.nativeElement) {
          this.testimonial.nativeElement.scrollIntoView({ behavior: 'smooth'});
        }
        break;
      case 'packsoffer':
        if (this.packsoffer && this.packsoffer.nativeElement) {
          this.packsoffer.nativeElement.scrollIntoView({ behavior: 'smooth'});
        }
        break;
    }
  }

  buyProductSimple(myVariantLabel){
    let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
    };
    this.shopifyService.buyProduct(orderObject);
  }

}
